import { render, staticRenderFns } from "./RegistrationViewSlotsGuests.vue?vue&type=template&id=b2f7d5f0&"
import script from "./RegistrationViewSlotsGuests.vue?vue&type=script&lang=js&"
export * from "./RegistrationViewSlotsGuests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports